<form [formGroup]="emailForm">
  <h1>{{ 'admin.global.email' | translate }}</h1>
  <p class="text-muted">{{ 'admin.account.provideEmailMsg' | translate }}</p>
  <div class="input-group mb-3">
    <app-input-text
      [bare]="true"
      [control]="$any(email)"
      placeholder="Email"
      autocomplete="email"
      [maxLength]="254"
      [customValidationMessages]="{ email: 'admin.forgot.emailInvalid' }"
    ></app-input-text>
    <div class="input-group-append">
      <span class="input-group-text"><i class="cui-user"></i></span>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <app-button
        type="button"
        variant="primary"
        classes="px-4"
        (click)="onSubmit()"
        [disabled]="emailForm.invalid"
      >
        {{ 'admin.forgot.submit' | translate }}
      </app-button>
    </div>
  </div>
</form>
